import React from 'react'
import { Link } from 'react-router-dom'
import i18n from 'i18next'

const TopSection = ({ activeType, currentImages, is_auth = false, t }) => (
    <div className="top-section">
        <ul className="top-section__balls">
            <li style={{ backgroundColor: activeType.balls[0] }} />
            <li style={{ backgroundColor: activeType.balls[1] }} />
            {activeType.balls[2] ? (
                <>
                    <li style={{ backgroundColor: activeType.balls[2] }} />
                    <li style={{ backgroundColor: activeType.balls[3] }} />
                    <li style={{ backgroundColor: activeType.balls[4] }} />
                </>
            ) : null}
        </ul>
        <div className="top-section__bg" style={{ backgroundColor: activeType.colors.main }} />
        <div className={`top-section__main-title lng-${i18n.language}`}>{t(activeType.texts.title)}</div>
        <div className="top-section__cols">
            <div className="top-section__cols-img">
                <div style={{ backgroundColor: activeType.balls[1] }} />
                {currentImages.top.main ? <img src={currentImages.top.main} alt="" /> : null}
            </div>
            <div className="top-section__cols-icon">
                {currentImages.top.main ? <img src={currentImages.top.icon} alt="" /> : null}
            </div>
            <div className="top-section__cols-description">
                {t(activeType.texts.description)}
                <div className="top-section__cols-description-buttons">
                    {activeType.isActive ? (
                        <>
                            <Link
                                to={`/template-gallery/${activeType.customId}`}
                                className="button-style"
                                data-size="lg"
                                data-variant="transparent"
                            >
                                {t(`view templates`)}
                            </Link>
                            <Link
                                to={`${
                                    is_auth ? `/template-gallery/${activeType.customId}` : '/auth?action=registration'
                                }`}
                                className="button-style"
                                data-size="lg"
                                data-variant="black-white--2"
                            >
                                {t(`create for free`)}
                            </Link>
                        </>
                    ) : (
                        <>
                            <button className="button" data-size="lg" data-variant="transparent" disabled>
                                {t(`Coming soon`)}
                            </button>
                            <a
                                href="mailto:info@interacty.me"
                                className="button-style"
                                data-size="lg"
                                data-variant="black-white--2"
                            >
                                {t(`send request`)}
                            </a>
                        </>
                    )}
                </div>
            </div>
        </div>
    </div>
)

export default TopSection
